import React from "react";
import { motion } from "framer-motion";
import {
    fadeSlideY,
    useEntryAnimation,
} from "../FramerMotionAnimations";

/**
 * Wrapper d'animation à l'apparition (au scroll) — même mécanique que les
 * sections existantes (framer-motion + useEntryAnimation/IntersectionObserver).
 *
 * Usage : remplace l'élément racine d'une section.
 *   <Reveal className={clx("container", style.wrapper)}> … </Reveal>
 *
 * - `variants` : variantes framer-motion (défaut : fadeSlideY = slide up + fade)
 * - `delay`    : retard d'apparition (s) — utile pour cascader plusieurs blocs
 * - `className`: appliqué au motion.div (conserve les classes de la section)
 */
export function Reveal({
    children,
    className,
    variants = fadeSlideY,
    delay = 0,
    style: inlineStyle,
    ...rest
}) {
    const [ref, setRef] = React.useState(null);
    const { hasAnimated } = useEntryAnimation(ref);
    const [windowWidth, setWindowWidth] = React.useState(null);
    const isMobile = windowWidth === null ? false : windowWidth < 800;

    React.useEffect(() => {
        setWindowWidth(window.innerWidth);
    }, []);

    // Applique le délai éventuel à la transition de la variante "animate".
    const resolvedVariants = delay
        ? {
              ...variants,
              animate: {
                  ...variants.animate,
                  transition: { ...(variants.animate?.transition || {}), delay },
              },
          }
        : variants;

    return (
        <motion.div
            ref={setRef}
            initial="initial"
            animate={(hasAnimated || isMobile) && "animate"}
            variants={resolvedVariants}
            className={className}
            style={inlineStyle}
            {...rest}
        >
            {children}
        </motion.div>
    );
}
